module.exports = __webpack_public_path__ + "static/media/Event-Carousels-Wellness.7fea4479.jpg";